import FormField from '@cloudscape-design/components/form-field';
import CSDInput from '@cloudscape-design/components/input';
import { get } from 'lodash';
import { Controller, useFormContext } from 'react-hook-form';

type InputProps = {
  name: string;
  label?: string;
  description?: string;
  defaultValue?: string;
  placeholder?: string;
  disabled?: boolean;
  stretch?: boolean;
  className?: string;
};

const Input = ({
  name,
  label,
  description,
  defaultValue = '',
  placeholder = '',
  disabled = false,
  stretch = false,
  className = '',
}: InputProps) => {
  const { control, formState } = useFormContext();

  return (
    <FormField
      stretch={stretch}
      description={description}
      label={label}
      className={className}
      errorText={get(formState.errors, name)?.message as string | undefined}
    >
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <CSDInput
            {...field}
            onChange={({ detail }) => field.onChange(detail.value)}
            placeholder={placeholder}
            disabled={disabled}
          />
        )}
      />
    </FormField>
  );
};

export default Input;
